<template>
  <footer class="relative z-10 w-full overflow-x-hidden bg-black">
    <div class="w-full">
      <div
        class="flex flex-wrap items-start justify-between md:px-10 px-5 max-w-[1440px] mx-auto w-full py-14"
      >
        <div class="flex flex-col items-start w-full mb-10 lg:w-1/4 lg:mb-0">
          <router-link to="/" class="mb-5">
            <LazyLoadingImage
              :src="$ImageUrl($GetColumn('footer_logo'))"
              class="w-44"
            />
          </router-link>
          <ol class="flex items-center justify-center w-44">
            <li class="px-3" v-if="$GetColumn('company_facebook') != ''">
              <a
                :href="$GetColumn('company_facebook')"
                target="_blank"
                class="text-white transition-all duration-300 hover:text-zinc-500"
              >
                <i class="text-xl text-current icon-facebook"></i>
              </a>
            </li>
            <li class="px-3" v-if="$GetColumn('company_instagram') != ''">
              <a
                :href="$GetColumn('company_instagram')"
                target="_blank"
                class="text-white transition-all duration-300 hover:text-zinc-500"
              >
                <i class="text-xl text-current icon-instagram"></i>
              </a>
            </li>
            <li class="px-3" v-if="$GetColumn('company_line') != ''">
              <a
                :href="$GetColumn('company_line')"
                target="_blank"
                class="text-white transition-all duration-300 hover:text-zinc-500"
              >
                <i class="text-xl text-current icon-line"></i>
              </a>
            </li>
            <li class="px-3" v-if="$GetColumn('company_youtube') != ''">
              <a
                :href="$GetColumn('company_youtube')"
                target="_blank"
                class="text-white transition-all duration-300 hover:text-zinc-500"
              >
                <i class="text-xl text-current icon-youtube"></i>
              </a>
            </li>
            <li class="px-3" v-if="$GetColumn('company_tiktok') != ''">
              <a
                :href="$GetColumn('company_tiktok')"
                target="_blank"
                class="text-white transition-all duration-300 hover:text-zinc-500"
              >
                <i class="text-xl text-current icon-tiktok"></i>
              </a>
            </li>
          </ol>
        </div>

        <div class="w-full mb-5 lg:w-1/4 md:w-1/2 lg:mb-0">
          <p
            class="pl-3 mb-5 text-sm font-bold text-white border-l-2 border-primary"
          >
            網站地圖
          </p>
          <ol>
            <li
              v-for="(item, item_index) in menu_list"
              :key="`menu_${item_index}`"
              class="mb-2"
            >
              <router-link
                :to="item.link"
                class="text-sm font-medium transition-all duration-300 text-zinc-500 hover:text-zinc-300 hover:underline"
              >
                {{ item.title }}
              </router-link>
            </li>
          </ol>
        </div>

        <div class="w-full mb-5 lg:w-1/4 md:w-1/2 lg:mb-0">
          <p
            class="pl-3 mb-5 text-sm font-bold text-white border-l-2 border-primary"
          >
            條款與規範
          </p>
          <ol>
            <li class="mb-1">
              <router-link
                to="/terms/site_privacy"
                class="text-sm font-medium transition-all duration-300 text-zinc-500 hover:text-zinc-300 hover:underline"
              >
                隱私權政策
              </router-link>
            </li>
            <li>
              <router-link
                to="/terms/return_policy"
                class="text-sm font-medium transition-all duration-300 text-zinc-500 hover:text-zinc-300 hover:underline"
              >
                退換貨政策
              </router-link>
            </li>
          </ol>
        </div>

        <div class="w-full lg:w-1/4 md:w-1/2">
          <p
            class="pl-3 mb-5 text-sm font-bold text-white border-l-2 border-primary"
          >
            聯絡資訊
          </p>
          <ol>
            <li class="flex items-center mb-2">
              <p class="mr-3 text-sm font-light text-white">聯絡電話</p>
              <p class="text-sm font-normal text-primary work_sans">
                {{ $GetColumn("company_phone") }}
              </p>
            </li>
            <li class="flex items-center mb-2">
              <p class="mr-3 text-sm font-light text-white">公司地址</p>
              <p class="text-sm font-normal text-primary work_sans">
                {{ $GetColumn("company_address") }}
              </p>
            </li>
            <li class="flex items-center mb-2">
              <p class="mr-3 text-sm font-light text-white">電子信箱</p>
              <p class="text-sm font-normal text-primary work_sans">
                {{ $GetColumn("company_email") }}
              </p>
            </li>
            <li class="flex items-center">
              <p class="mr-3 text-sm font-light text-white">營業時間</p>
              <p class="text-sm font-normal text-primary work_sans">
                {{ $GetColumn("company_time") }}
              </p>
            </li>
          </ol>
        </div>
      </div>
    </div>
    <div class="w-full">
      <div
        class="max-w-[1440px] mx-auto w-full flex-wrap py-4 flex items-center justify-center md:px-10 px-5"
      >
        <div class="flex justify-center w-full md:w-auto">
          <button
            @click="ScrollToTop"
            class="inline-flex items-center py-2 pl-8 pr-6 text-sm font-bold text-white transition-colors duration-500 bg-opacity-50 border border-black sm:text-base bg-primary md:hover:bg-opacity-100"
          >
            回到頂部
            <i class="block ml-3 transform -rotate-90 icon-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="w-full border-t border-white border-opacity-10">
      <div
        class="flex items-center flex-wrap justify-center md:justify-between md:px-10 px-5 max-w-[1440px] mx-auto w-full py-4"
      >
        <p class="mb-2 text-xs work_sans text-gray md:mb-0">
          ©{{ year }} {{ $GetColumn("company_name") }}
        </p>

        <p class="w-full text-xs text-center text-gray md:w-auto md:text-start">
          DESIGN BY
          <a
            class="ml-2 text-primary"
            href="https://www.yongxin-design.com"
            target="_blank"
            >泳欣事業有限公司</a
          >
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import LazyLoadingImage from "@/components/LazyLoadingImage.vue";
export default {
  name: "MainFooter",
  components: {
    LazyLoadingImage,
  },
  data() {
    return {
      menu_list: [
        {
          title: "關於我們",
          sub_title: "About",
          link: "/about",
        },
        {
          title: "商品列表",
          sub_title: "Products",
          link: "/scooters/all",
        },
        {
          title: "最新消息",
          sub_title: "News",
          link: "/news",
        },
        {
          title: "影音專區",
          sub_title: "Video",
          link: "/video/list",
        },
        {
          title: "客服中心",
          sub_title: "Contact",
          link: "/support",
        },
        {
          title: "經銷據點",
          sub_title: "Dealers",
          link: "/dealers",
        },
      ],
    };
  },
  methods: {
    ScrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
